// Payload for search values
export const searchValuesPayload = ({ page, pageSize, searchKey }) => ({
  page,
  pageSize: pageSize,
  searchKey: searchKey,
});
